// src/components/freemium/FreemiumJourneyHeader.tsx
// Shared header component for Freemium journey pages
// Combines ProJourneyPageHeader with FreemiumTabs

import React from 'react';
import ProJourneyPageHeader from '../journey/pro/ProJourneyPageHeader';
import FreemiumTabs from './FreemiumTabs';

interface FreemiumJourneyHeaderProps {
  /** Step number (1-4) */
  stepNumber: number;
  /** Step name (e.g., "Snapshot", "Personalize", "Data Strategy Overview") */
  stepName: string;
  /** Description text - concise one-liner */
  description: string;
  /** Optional message count for Messages tab badge */
  messageCount?: number;
}

export default function FreemiumJourneyHeader({
  stepNumber,
  stepName,
  description,
  messageCount = 0,
}: FreemiumJourneyHeaderProps) {
  return (
    <div className="mb-6">
      {/* Tabs row - positioned above header, right-aligned */}
      <FreemiumTabs messageCount={messageCount} />
      
      {/* Step header - positioned below tabs */}
      <div className="-mt-2">
        <ProJourneyPageHeader
          stepNumber={stepNumber}
          stepName={stepName}
          description={description}
        />
      </div>
    </div>
  );
}

